import { SkeletonCard, SkeletonHeader } from '@/components/skeleton-common'
import { Skeleton } from '@/components/ui/skeleton'

function HomePageSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 py-6 lg:px-6">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center space-y-2">
        <SkeletonHeader />
        <Skeleton className="h-4 w-full max-w-lg" />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <SkeletonCard className="h-40 md:col-span-2" />
        <SkeletonCard className="h-40" />
        <SkeletonCard className="h-40" />
        <SkeletonCard className="h-40" />
        <SkeletonCard className="h-40" />
      </div>
    </div>
  )
}

HomePageSkeleton.displayName = 'HomePageSkeleton'

export { HomePageSkeleton }
